import React from 'react';
import styled from 'styled-components';
import { IconNames } from '@blueprintjs/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Message from 'rc-message';
import { Icon, Intent } from '@blueprintjs/core';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';

import Clearfix from 'components/elements/clearfix';
import DisplayField from 'components/elements/display-field';
import slug from 'constants/slug';
import AttachmentContainer from 'containers/AttachmentContainer';
import { getOne, deleteOne } from 'api/legalDocumentApi';
// import {
//   getList as getAttachList,
//   deleteOne as deleteAttach,
//   create as createAttach,
// } from 'api/legalDocumentApi';
import {
  getList as getAttachList,
  deleteOne as deleteAttach,
  create as createAttach,
} from 'api/legalDocumentAttachmentApi';
import { getLookupTypeLegalDocumentAttachment } from 'api/lookuplistitemApi';
import Confirm from 'components/elements/confirm-element';
import { DATE_FORMAT, DATETIME_FORMAT } from 'config';
import { COLOR } from 'config';

const ContainerWrapper = styled.div``;
const ContainerHeader = styled.div`
  display: flex;
`;
const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const Content = styled.div``;

@PageLockHOC(['legalDocument.view'])
export default class LegalDocumentView extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: {},
    initialDetail: [],
  };

  getId() {
    const _id = _.result(this.props, 'match.params._id');
    return _id;
  }

  async checkValidate() {
    const _id = this.getId();
    if (_id) {
      const res = await getOne(_id);
      if (res.success) {
        this.setState({
          _idObject: _id,
          isLoading: false,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.LEGAL_DOCUMENTS.LIST);
    }
  }

  updateInitialValue = (values) => {
    this.setState({
      _idObject: values._id,
      isLoading: false,
      initialValue: values,
    });
  };

  componentWillMount = async () => {
    await Promise.all([this.checkValidate()]);
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value || value === '') {
      return '';
    }
    switch (type) {
      case 'date':
        return moment(value).format(DATE_FORMAT);
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const LegalDocumentNumber = this.getInitialValue('LegalDocumentNumber');

      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xoá số văn bản: `} <b>{LegalDocumentNumber}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(slug.LEGAL_DOCUMENTS.LIST);
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  render() {
    return (
      <ContainerWrapper>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        {!this.state.isLoading && (
          <div>
            <ContainerHeader>
              <h3
                style={{
                  color: COLOR.SECOND_COLOR,
                }}
                className='bp3-heading'
              >
                Quản lý văn bản pháp lý
              </h3>
            </ContainerHeader>
            <ContainerAction>
              <div style={{ display: 'inline-flex' }}>
                <Icon
                  onClick={() => {
                    this.props.history.push(slug.LEGAL_DOCUMENTS.LIST);
                  }}
                  style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                  icon={IconNames.CIRCLE_ARROW_LEFT}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.SUCCESS}
                />

                <Permissions allowed={[`legalDocument.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={
                        slug.LEGAL_DOCUMENTS.EDIT_WITH_ID +
                        this.getInitialValue('_id')
                      }
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>

                <Permissions allowed={[`legalDocument.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </div>
            </ContainerAction>
            <Clearfix height={12} />
            <Content>
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Số văn bản'
                value={this.getInitialValue('LegalDocumentNumber')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Bộ phận ban hành'
                value={this.getInitialValue('promulgate.Name', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Loại văn bản'
                value={this.getInitialValue('type.Name', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Nội dung văn bản'
                value={this.getInitialValue('Content')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Lĩnh vực'
                value={this.getInitialValue('mainField.Name')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Người ký'
                value={this.getInitialValue('Signer')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ngày ban hành'
                value={this.getInitialValue('IssueDate', '', 'date')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ngày hết hạn'
                value={this.getInitialValue('ExpiryDate', '', 'date')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Tình trạng'
                value={this.getInitialValue('status.Name', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ghi chú'
                value={this.getInitialValue('Note', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Thêm vào'
                value={`${this.getInitialValue('AddedOn')
                  ? moment(this.getInitialValue('AddedOn')).format(
                    DATETIME_FORMAT
                  ) +
                  ' bởi ' +
                  this.getInitialValue('AddedBy')
                  : ''
                  } `}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Cập nhật lần cuối'
                value={`${this.getInitialValue('UpdatedOn')
                  ? moment(this.getInitialValue('UpdatedOn')).format(
                    DATETIME_FORMAT
                  ) +
                  ' bởi ' +
                  this.getInitialValue('UpdatedBy')
                  : ''
                  } `}
              />
              <Clearfix height={32} />
              <AttachmentContainer
                // hideButtonAction={false}
                facility={this.state.initialValue}
                getListFunc={(query) => {
                  return getAttachList({
                    ...query,
                    legalDocument: this.getInitialValue('_id'), //_id của inspection
                  });
                }}
                createOne={(values) => {
                  values.legalDocument = this.getInitialValue('_id');
                  return createAttach(_.pickBy(values, _.identity));
                }}
                deleteOne={deleteAttach}
                getAttachmentTypeList={getLookupTypeLegalDocumentAttachment}
                moduleName='legalDocument'
              />
            </Content>
          </div>
        )}
      </ContainerWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/LegalDocument/LegalDocumentView/index.js